import React from "react";

const ProfilePayments = () => {
  return <div>ProfilePayments</div>;
};

export default ProfilePayments;
